import './Homepage.scss'
import ArticlesWidgets  from '../../components/ArticlesWidgets'
import ComponentObserver  from '../ComponentObserver'
import Head from '../Head'
import HTMLWidgetRenderer from '../../components/HTMLWidgetRenderer'
import LazyComponent from '../../components/LazyComponent'
import NewsFeed from '../NewsFeed'
import React from 'react'
import SpecialBanner from './SpecialPageBanner'
import translate from '../../utilities/translate'
import translations from './translations'
import Headlines from '../../components/Headlines/Homepage'
import TopArticles from './TopArticles'
import Divider from '../../widgets/Layout/Divider'
import StickyBottomBanner from '../StickyBottomBanner'
import {
  HomepageAdvertProvider,
  AsideDesktopAdvert,
  HomepageTopArticlesAfterMobileDesktopAdvert,
  HomepageBelowArticlesMobileDesktopAdvert,
  HomepageAfterSectionMobileAdvert,
} from '../../components/Adverts/Taboola'
import { DESKTOP_VIEWPORT, MOBILE_VIEWPORT } from '../../utilities/constants'
import { BelowVideoDesktopAdvert, SectionMobileDesktopAdvert, Side1DesktopAdvert, Side2DesktopAdvert } from '../../components/Adverts/Adnimation'
import MostPopular from './MostPopular'
import { isHebrew, isPersian } from '../../utilities/locales'
import PropTypes from 'prop-types'

// trans :: String -> String -> String
const trans = translate(translations)

const LatestVideos = LazyComponent('LatestVideos')
const I24NewsPlusVideos = LazyComponent('I24NewsPlusVideos')
const FeaturedCategories = LazyComponent('FeaturedCategories')

const Homepage = ({
  locale,
  viewport,
  isTruvidInitialized,
}) =>
  <>
    <Head title={ trans(locale)('title')  } description={ trans(locale)('metaDescription') } withDefaultTitle={ false }>
      <HomepageAdvertProvider>
        <div id="homepage" className="page-content">
          <section className="container container-page banners special">
            <SpecialBanner />
          </section>
          <div className="container container-page">
            <Divider variant='thin'/>
            <Headlines />
          </div>

          {/* i24News+ */}
          { !isHebrew(locale) && !isPersian(locale)
            ? <section className="i24news-plus">
              <div className="container container-page">
                <ComponentObserver componentId="i24news-plus-slider" component={ I24NewsPlusVideos } />
              </div>
            </section>
            : null
          }

          {/* latest videos */}
          <section className="latest-videos banner-section">
            <div className="wrapper">
              <div className="container container-page">
                <ComponentObserver componentId="latest-videos" component={ LatestVideos } />
              </div>
            </div>
          </section>

          { viewport !== MOBILE_VIEWPORT
            ? <section className="column-ads banner-section">
              <div className="container container-page">
                <BelowVideoDesktopAdvert locale={ locale } />
                <Divider />
              </div>
            </section>
            : null
          }

          {/* top articles & articles widgets */}
          <section className="top-articles banner-section">
            <div className="container container-page">
              <div className="columns">
                <div className="column col-8 col-md-12">
                  <ComponentObserver componentId="articles-widgets" component={ ArticlesWidgets }/>
                  <div className="main-column">
                    <TopArticles />
                    { viewport === MOBILE_VIEWPORT
                      ? <>
                        <HomepageAfterSectionMobileAdvert index={ 1 } />
                        <Divider />
                      </>
                      : null
                    }
                    { isTruvidInitialized ? <MostPopular /> : null }
                  </div>
                </div>
                <div className="column col-4 col-md-12 aside-column">
                  { viewport === MOBILE_VIEWPORT
                    ? <>
                      <SectionMobileDesktopAdvert locale={ locale } index={ 0 } viewport={ MOBILE_VIEWPORT } />
                      <Divider />
                    </>
                    : null
                  }
                  <NewsFeed aside />
                  { viewport !== MOBILE_VIEWPORT ? <Side1DesktopAdvert locale={ locale } /> : null }
                </div>
              </div>
            </div>
          </section>

          <section className="column-ads banner-section">
            <div className="container container-page">
              <HomepageTopArticlesAfterMobileDesktopAdvert viewport={ viewport } />
              <Divider />
              { isHebrew(locale) ? <HTMLWidgetRenderer.Counters locale={ locale } /> : null }
            </div>
          </section>

          {/* featured categories */}
          <section className="featured-categories articles-widgets banner-section">
            <div className="container container-page">
              <div className="columns">
                <div className="column col-8 col-md-12">
                  <ComponentObserver
                    componentId="featured-categories"
                    component={ FeaturedCategories }
                    // Displaying the same Taboola ads on a page implies having a different ID.
                    // Headlines are already index 0 and Top article are index 1.
                    // So each category needs to have an index greater than 1 (offset of 2)
                    offset={ 2 }
                  />
                </div>
                { viewport !== MOBILE_VIEWPORT
                  ? <div className="column col-4 col-md-12">
                      <Side2DesktopAdvert locale={ locale } />
                      <AsideDesktopAdvert />
                  </div>
                  : null
                }
              </div>
            </div>
          </section>
          <section className="column-ads banner-section">
            <div className="columns container container-page">
              <div className="column col-8 col-md-12">
                <HomepageBelowArticlesMobileDesktopAdvert />
              </div>
            </div>
          </section>
        </div>
      </HomepageAdvertProvider>
    </Head>
    { viewport === DESKTOP_VIEWPORT ? <StickyBottomBanner /> : null }
  </>

Homepage.propTypes = {
  locale: PropTypes.string.isRequired,
  viewport: PropTypes.string.isRequired,
  isTruvidInitialized: PropTypes.bool.isRequired,
}

export default Homepage
